import cx from 'classnames';
import { TypographyTitleProps } from './types';
import { getCommonClassName } from './utils';
import { ElementType } from 'react';

export const Title = <T extends ElementType = 'div'>({
  children,
  size = 'medium',
  component,
  className,
  strong,
  shadow,
  italic,
  color,
  align,
  textWrap,
  transform,
  underlineOnHover,
  ...props
}: TypographyTitleProps<T>) => {
  const Component = component || 'div';
  return (
    <Component
      className={cx(
        `slds-text-heading--${size}`,
        getCommonClassName({ strong, shadow, italic, color, className, align, textWrap, transform, underlineOnHover })
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
